import { beforeMain } from "@popperjs/core"

export default [
    {
        path: "/",
        redirect: "/residences",
    },
    {
        path: "/residences",
        name: "Residences",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
                "G_CODE_TEL",
                "G_CODE_CLAV",
            ],
            tab: "residences",
        },
        component: () => import("@/views/residence/List.vue"),
    },
    {
        path: "/residence/:id(\\d+)/:tab(details|authorizations|codes|central-units|subaccounts)?/:page_num?",
        name: "Residence",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
                "G_CODE_TEL",
                "G_CODE_CLAV",
            ],
            entity: "residence",
            tab: "residences",
        },
        component: () => import("@/views/residence/Details.vue"),
    },
    {
        path: "/:type(residence|building|stairwell)/:id(\\d+)/cylinder/:idcylinderaccess(\\d+)/update",
        name: "CylinderUpdate",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
                "G_CODE_TEL",
                "G_CODE_CLAV",
            ],
            entity: "cylinder",
            tab: "residences",
        },
        component: () => import("@/views/cylinder/Update.vue"),
    },
    {
        path: "/:type(residence|building|stairwell)/:id(\\d+)/cylinder/:idcylinderaccess(\\d+)/replace",
        name: "CylinderReplace",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
                "G_CODE_TEL",
                "G_CODE_CLAV",
            ],
            entity: "cylinder",
            tab: "residences",
        },
        component: () => import("@/views/cylinder/Update.vue"),
    },
    {
        path: "/residence/:id(\\d+)/export_fobs",
        name: "ExportFobsResidence",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
                "G_CODE_TEL",
                "G_CODE_CLAV",
            ],
            privileges: ["LAST_KEY"],
            entity: "residence",
            tab: "residences",
        },
        component: () => import("@/views/residence/ExportFobsView.vue"),
    },
    {
        path: "/:type(residence|building|stairwell)/:id(\\d+)/cylinder/:idcylinderaccess(\\d+)",
        name: "CylinderDetails",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
                "G_CODE_TEL",
                "G_CODE_CLAV",
            ],
            entity: "cylinder",
            tab: "cylinder",
        },
        component: () => import("@/views/cylinder/Details.vue"),
    },
    {
        path: "/apartment",
        name: "Apartments",
        meta: {
            layout: "PrivateLayout",
            authorize: [
                "G_KEY",
                "G_KEY_MOBIL",
                "G_CLEPASS",
                "G_FICHES",
                "G_APP",
                "G_APP_NOM",
                "G_KEY_MOVE",
                "G_NAME_MOVE",
                "G_RESIDENCES",
                "G_KIBOLT",
                "G_TAGIT",
                "G_CONNECTIT",
            ],
            entity: "apartment",
            tab: "residences",
        },
        component: () => import("@/components/entities/ApartmentsList.vue"),
    },
    {
        path: "/helpdesk",
        name: "HelpDesk",
        meta: {
            layout: "PrivateLayout",
            authorize: [],
            tab: "others",
        },
        component: () => import("@/views/home/Support.vue"),
    },
    {
        path: "/update-module/:search?",
        name: "UpdateModule",
        meta: {
            layout: "PrivateLayout",
            authorize: [],
            tab: "others",
        },
        component: () => import("@/views/updateModule/UpdateModule.vue"),
        beforeEnter: (to, from, next) => {
            next()
        },
    },
    {
        path: "/update-module/:id(\\d+)",
        name: "ModuleDetails",
        meta: {
            layout: "PrivateLayout",
            authorize: [],
            tab: "others",
        },
        component: () => import("@/views/updateModule/Details.vue"),
    },
    {
        path: "/amazon-key/:accessId",
        name: "AmazonKey",
        meta: {
            layout: "PrivateLayout",
            authorize: ["G_RESIDENCES"],
            tab: "others",
        },
        component: () => import("@/views/amazonKey/index.vue"),
    },
    {
        path: "/:type(residence|stairwell)/flyers/:id(\\d+)",
        name: "StairwellFlyer",
        meta: {
            layout: "PrivateLayout",
            authorize: [],
            tab: "others",
        },
        component: () => import("@/views/flyers/StairwellFlyer.vue"),
    },
    {
        path: "/monibox/:action/:id(\\d+)?",
        name: "PortaBox",
        meta: {
            layout: "PrivateLayout",
            authorize: [],
            tab: "residences",
        },
        component: () => import("@/views/monibox/index.vue"),
    },
]
